export default __webpack_public_path__ + "static/media/lake.04c9b856.svg";